import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-grafica-bar',
  templateUrl: './grafica-bar.component.html',
  styleUrls: ['./grafica-bar.component.css']
})
export class GraficaBarComponent implements OnChanges {
  
  @Input() public barChartLabels:any[] = [];
  @Input() public barChartData:any[] = [];
  
  constructor() { }

  ngOnChanges() {
    this.getDataBarInputs();
  }

  private async getDataBarInputs() {
    
    let arrayTemp : any [] = [];
    await this.barChartData;
    
    for (let i = 0; i < this.barChartLabels.length; i++) {
      arrayTemp.push((i+1));
    }

    this.barChartLabels = await arrayTemp;

  }

  public barChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  
  public barChartType:string = 'bar';
  public barChartLegend:boolean = true;
 
  // events
  public chartClicked(e:any):void {
    //console.log(e);
  }
 
  public chartHovered(e:any):void {
    //console.log(e);
  }

}
